<ng-container [formGroup]="form">
  <ng-container formArrayName="items">
    <div *ngFor="let _ of formArray.controls; index as i" fxLayout="row">
      <digital-platform-waste-component-row
        [formControlName]="i"
        [showPpm]="showPpm"
        [hideLabels]="i > 0"
        [isRequired]="i === 0 && isRequired"
        [isToggled]="isToggled"
        [sum]="sum"
        [labels]="labels"
        [isLegacy]="isLegacy"
        [tabIndex]="tabIndex + i + 1"
      ></digital-platform-waste-component-row>
      <div class="delete-row-button" *ngIf="rowCount > 1">
        <a
          [ngClass]="i >= 1 ? 'button-label' : 'button-no-label'"
          mat-button
          (click)="deleteRow(i)"
          color="accent"
          matTooltip="Delete"
        >
          <mat-icon>delete_outline</mat-icon>
        </a>
      </div>
    </div>
  </ng-container>
</ng-container>

<button
  [tabIndex]="tabIndex + 4"
  mat-button
  color="accent"
  class="semi-bold-text add-another-component"
  [disabled]="!isToggled && sum >= 100"
  (click)="addItem()"
>
  <mat-icon>add</mat-icon> Add Another Characteristic
</button>
